export const getIsInJosh = () => window.joshAction != null;
export const getJoshApi = () => window.joshAction;
